import React from "react";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "../../../components/Layout/Breadcrumb";
import { getUserProfile } from "../../../helpers/functions_helper";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = (props: any) => {
  const { t } = useTranslation();
  const location = useLocation();
  const moduleAccess = getUserProfile("immigration");

  return (
    <React.Fragment>
      <Breadcrumbs
        breadcrumbTitle={t("Immigration")}
        breadcrumbItems={props?.breadcrumbItems}
        endAdornment={
          <div className="d-flex gap-2 text-end">
            <Link
              to="/immigration/list"
              className={`btn btn-label btn-sm ${window.location.pathname === "/immigration/list" ? "btn-info" : "btn-outline-secondary"}`}
            >
              <span className="align-middle material-symbols-outlined fw-light fs-4 label-icon">
                list_alt
              </span>
              {t("List view")}
            </Link>

            {moduleAccess.CAN_CREATE ? (
              <Link to={`/immigration/create-profile`} className="btn btn-primary btn-label btn-sm">
                <span className="align-middle material-symbols-outlined fw-light fs-4 label-icon">
                  add
                </span>{" "}
                {t("Create Immigration Profile")}
              </Link>
            ) : null}
          </div>
        }
      />
    </React.Fragment>
  );
};

export default Breadcrumb;
